import {IAnalyticsProvidersConfiguration} from 'coreClasses/analytics/IAnalytics';
import EventModel from './eventModels/EventModel';

export interface IDataLayerEvent {
	[key: string]: any;
}

export interface IGoogleTagManagerConfiguration extends IAnalyticsProvidersConfiguration {
	containerId: string;
	containerBaseUrls?: Record<string, string>;
	[key: string]: any;
}

export interface IPersistentEvent {
	position: number;
	event: EventModel;
}

export type IPersistentEvents = Partial<Record<EGoogleTagManagerEventType, IPersistentEvent>>;

export enum EGoogleTagManagerEventType {
	PAGE_VIEW = 'Pageview',
	LOGS_IN = 'LogsIn',
	LOGS_OUT = 'LogsOut',
	CHANGE_LOCAL = 'ChangeLocal',
	SPLASH_PAGE_VIEW = 'SplashPageview',
	CUSTOMER_CHANGED = 'userInfo',
	CUSTOMER_REGISTRATION = 'accountCreation',
	NEWSLETTER_SUBSCRIPTION = 'newsletterSubscription',
	PRODUCT_CLICK = 'eec.productClick',
	PRODUCT_LIST_LOAD = 'eec.productListLoad',
	PRODUCT_DETAIL_VIEW = 'eec.productView',
	PRODUCT_ADD_TO_CART = 'eec.addToCart',
	PRODUCT_REMOVE_FROM_CART = 'eec.removeFromCart',
	PRODUCT_ADD_TO_WISHLIST = 'wishlistAdd',
	RECOMMENDATIONS_LOADED = 'recommendationReady',
	SEARCH_QUERY = 'search',
	PROMOTION_CLICK = 'promotionClick',
	PROMOTION_VIEW = 'promotionView',
	VIEW_SIZES = 'view_sizes',
	CART_UPDATED = 'cartUpdated',
	WISHLIST_UPDATED = 'wishlistUpdated',
	CLICK_IMAGE_CTA = 'clickImageCta',
}

export enum ENewsletterSubscriptionSection {
	MY_ACCOUNT = 'MY ACCOUNT',
	SIGN_UP = 'SIGN UP PAGE',
	NEWSLETTER_POPUP = 'NL POPUP',
	FOOTER = 'FOOTER',
	NOTIFY_ME = 'NOTIFY ME POPUP',
	NEWSLETTER_PAGE = 'NL PAGE',
	WAITINGLIST_NEWSLETTER = 'NL WAITING LIST',
}

export enum EGoogleTagManagerEventSource {
	HOME = 'Homepage',
	PLP = 'ProductListPage',
	PDP = 'ProductPage',
	SP = 'SplashPage',
	CUSTOMER_SERVICE = 'Customer Service',
	OTHER = 'Other',
	SEARCH_RESULTS = 'search-results',
	SEARCH_PREVIEW = 'search-preview',
	FULL_SEARCH_RESULTS = 'full-search-results',
	YOU_MAY_ALSO_LIKE = 'you-may-also-like',
	WEAR_THIS_WITH = 'wear-this-with',
	RECENTLY_VIEWED = 'recently-viewed',
	RECOMMENDATION = 'recommendation',
	CART = 'cart',
	WISHLIST = 'wishlist',
	MY_ACCOUNT = 'My Account',
	SIZE_SELECTOR = 'select_size',
	ADD_TO_CART = 'add_to_cart',
	VIRTUAL_TRY_ON = 'VTO Tool',
}

export interface IEcommerceData {
	[key: string]: any;
}
